<template>
  <div class="container2" style="background:#fff;margin-top:10px">
    <div class="container2 work-wrapper">
      <div>
        <div class="projectInfo">
          <div class="blockHeader">
            <div class="redBlock"></div>
            <div class="headerText">作业列表</div>
            <div class="workListTable" id="nav">
              <span
                class="workItem"
                v-for="(item,index) in works"
                :key="item.id"
                :class="{activeWorkItem:index==workIndex}"
                @click="workClick(item.id,item.name,index)"
              >
                <span class="workItemText">{{item.name}}</span>
              </span>
            </div>
            <el-button v-show="downloadExcelShow" class="download" type="warning" plain @click="downloadExcel" icon="el-icon-download">数据下载</el-button>
            <el-button v-show="!downloadExcelShow" class="download" type="warning" :loading="true" plain>下载..</el-button>
            
            <el-button class="copyBtn" type="warning" plain @click="toWorkRE">作业回放</el-button>
            <el-button class="addBtn" type="danger" @click="toWorkCheck">作业验收</el-button>
            
          </div>
          <div class="line" style="height:1px;background-color:#E1E1E1;width:97.7%;margin:0 auto"></div>
          <div class="blockContent" style="margin-top: 14px">
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">作业名称</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.name"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.name}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">所属工程</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.projectName"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.projectName}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">创建时间</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.createTime"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.createTime}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">实际完成时间</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.endTime"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.endTime}}</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">开工时间</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.startTime"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.startTime}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">计划竣工时间</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.planEndTime"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.planEndTime}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">剩余时间</div>
                <div class="itemRight">
                  <span v-if="!isLook" class="infoShow">{{workObj.surplus}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">联系电话</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.principalPhone"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.principalPhone}}</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">作业单位</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.consUnit"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.consUnit}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">监理单位</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.supervisor"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.supervisor}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">总负责人</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.principal"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.principal}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">完成百分比</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.pecent"></el-input>
                  <span v-if="!isLook" class="infoShow">{{(workObj.workProcess *100).toFixed(2)}}%</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">作业类型</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.workTypeText"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.workTypeText}}</span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">作业区域</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.sectionName"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.sectionName}}</span>
                </div>
              </div>
              <div class="item_type2">
                <div class="itemLeft">关联设备</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.equipNames"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.equipNames}}</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">当前状态</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.status"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.statusText}}</span>
                </div>
              </div>
              <div class="item_type1" v-show="this.workObj.workType==3 || this.workObj.workType==4">
                <div class="itemLeft">总作业里程</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.sumMileage"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.sumMileage}}km</span>
                </div>
              </div>
              <div class="item_type2" v-show="this.workObj.workType==3 || this.workObj.workType==4">
                <div class="itemLeft">已完成里程</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.curMileage"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.curMileage}}km</span>
                </div>
              </div>
              <div class="item_type1" v-show="this.workObj.workType==1 || this.workObj.workType==2">
                <div class="itemLeft">总作业面积</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.sumArea"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.sumArea}}m²</span>
                </div>
              </div>
              <div class="item_type2" v-show="this.workObj.workType==1 || this.workObj.workType==2">
                <div class="itemLeft">已完成面积</div>
                <div class="itemRight">
                  <el-input v-if="isLook" class="infoShow" v-model="workObj.curArea"></el-input>
                  <span v-if="!isLook" class="infoShow">{{workObj.curArea}}m²</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TabPanel v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" title="压实质量" :tabList="tabList1" @tabChange="tabChange1" v-if="works.workType!=3" :activeCode="activeCode">
        <!-- 碾压遍数 -->
        <template>
          <rollingTimes :rollingTimesData="rollingTimesData" :activeIndex1Code="activeIndex1"/>
        </template>
        <!-- 压实度 -->
        <template>
          <rollingIcv :joinTypeV="joinTypeV" :workId="workId" :rollingIcvData="rollingIcvData" :activeIndex1Code="activeIndex1" />
        </template>
        <!-- 高程 -->
        <!-- <template v-if="false">
          <rollingAltitude :rollingAltitudeData="rollingAltitudeData" :activeIndex1Code="activeIndex1" />
        </template> -->
        <!-- 效率 -->
        <template>
          <rollingEfficiency :workId="workId" :rollingEfficiencyData="rollingEfficiencyData" :activeIndex1Code="activeIndex1" :workType="workType"/>
        </template>
        <!-- 效率 -->
        <!-- <template v-if="activeIndex1==3">
          <div class="ly1">
            <LeftList :data="testLeft" />
            <div class="ly1-right" style="margin-top:10px">
              <ChartLine height="520px" />
            </div>
          </div>
        </template> -->
        <!-- 轨迹 -->
        <template>
          <rollingTrace :workId="workId" :activeIndex1Code="activeIndex1" :workName="works[workIndex].name"/>
        </template>
      </TabPanel>
      <TabPanel title="摊铺质量" :tabList="tabList2" @tabChange="tabChange2" v-if="workObj.workType== 3 || workObj.workType== 4" :activeCode="activeCode">
        <!-- 温度 -->
        <template>
          <pavingTemperature :activeIndex2Code="activeIndex2" :pavingQualityTemperatureData="pavingQualityTemperatureData" />
        </template>
        <!-- 速度 -->
        <template>
          <pavingSpeed :activeIndex2Code="activeIndex2" :pavingQualitySpeed="pavingQualitySpeed" />
        </template>
        <!-- 效率 -->
        <template>
          <pavingEfficiency :workId="workId" :pavingEfficiencyData="pavingEfficiencyData" :activeIndex2Code="activeIndex2" />
        </template>
        <!-- 轨迹 -->
        <template>
          <pavingTrace :workId="workId" :workName="works[workIndex].name" :activeIndex2Code="activeIndex2"/>
        </template>
      </TabPanel>
    </div>
  </div>
</template>

<script>
import TabPanel from "../../../components/common/tabPanel";
import pavingSpeed from "./workPanel/pavingSpeed";
import pavingTemperature from "./workPanel/pavingTemperature";
import pavingTrace from "./workPanel/pavingTrace";
import pavingEfficiency from "./workPanel/pavingEfficiency"
import rollingEfficiency from "./workPanel/rollingEfficiency"
import rollingTrace from "./workPanel/rollingTrace";
// import rollingAltitude from "./workPanel/rollingAltitude";
import rollingTimes from "./workPanel/rollingTimes";
import rollingIcv from "./workPanel/rollingIcv";
import {getWorks,
        getWorkInfo,
        rollingQualityTimes,
        rollingQualityIcv,
        // rollingQualityAltitude,
        rollingQualityEfficiency,
        pavingQualityTemperature,
        pavingQualitySpeed,
        pavingQualityEfficiency,
        exportExcelQualityReport
       } from "../../../utils/api";
import {getNowDataNum,getDateSeconds} from "../../../utils/commons";
import { Message} from 'element-ui';
export default {
  data() {
    return {
      activeCode: 0,
      tabList1: ["碾压遍数", "压实度",  "效率", "轨迹"],
      tabList2: ["温度", "速度" ,"效率", "轨迹"],
      activeIndex1: -1,
      activeIndex2: -1,
      testLeft: {
        最大值: 105,
        最小值: 50,
        标准差: 10,
        过压率: "1%",
        欠压率: "0.5%",
      },
      workIndex: 0,
      isLook: false,
      works: '',
      workObj: '',
      rollingTimesData: {},
      rollingIcvData: {},
      // rollingAltitudeData: {},
      rollingEfficiencyData: {},
      pavingQualityTemperatureData: {},
      pavingQualitySpeed: {},
      pavingEfficiencyData: {},
      upDataCode: 0,
      workId: 0,
      workName: '',
      downloadExcelShow: true,
      joinTypeV: 1,
      loading: true
    };
  },
  props: {
    projectId: {
      type: Number,
      default: function(){
        return 0
      }
    },
    workType:{
      type: Number,
      default: function(){
        return 2
      }
    }
  },
  computed: {
    // works() {
    //   return this.$store.getters["quality/works"];
    // },
    // workObj() {
    //   return this.works[this.workIndex] || {};
    // },
  },
  watch: {
    projectId: function(newValue){
      //console.log(newValue)
      let params = {
        projectId: newValue
      }
      let that = this
      that.activeCode = 1
      getWorks(params).then(res=> {
        //console.log(res)
        that.works = res.data.content.info.list
        let par = {
          id: res.data.content.info.list[0].id
        }
        this.workId = res.data.content.info.list[0].id;
        this.workName = res.data.content.info.list[0].name;
        getWorkInfo(par).then(res=> {
          //console.log(res)
          var that = this;
          let roadWidth = (res.data.content.info.roadWidth)
          let deviationUnit = res.data.content.info.deviationUnit
          let setRoadWidth = []
          let code = deviationUnit
          for(let i=0;i<100;i++){
            // for(let j=0;j<10;j++){
            //   setRoadWidth.push(i+j/10)
            // }
            if(i*code<=(roadWidth*1+code*1)){
              setRoadWidth.push(code*10*i/10)
            }
          }
          
          this.$store.commit('setRoadWidth', setRoadWidth)
          this.$store.commit('deviationUnit', deviationUnit)
          this.workObj = res.data.content.info;
          let workTypeList = this.$store.state.workTypeList;
          let statusList = this.$store.state.statusList;
          this.workObj.workTypeText = workTypeList[this.workObj.workType];
          this.workObj.statusText = statusList[this.workObj.status];
          //标准道路
          this.workObj.pecent = this.workObj.sumMileage==0?'0.0%':((this.workObj.curMileage/this.workObj.sumMileage)*100).toFixed(1) + '%';
          this.workObj.surplus = getNowDataNum(this.workObj.planEndTime);
          //console.log(this.workObj)
          let timer=setTimeout(function(){
            //console.log('改变')
            that.activeIndex1 = 0
            that.activeIndex2 = 0
            that.activeCode = 0
            clearTimeout(timer)
            },5000);
          this.getAllInfo(this.workId);
          if(this.workObj.workType == 1 || this.workObj.workType == 2){
            this.joinTypeV = 0
          }else{
            this.joinTypeV = 1
          }
        })
        
        
      })
    }
  },
  created() {},
  mounted() {},
  methods: {
    //下载质量excel表格
    async downloadExcel(){
      let userRoleList = localStorage.getItem("userRoleList")
      if(userRoleList.indexOf("menu-3d3f6767511144d7acb504148f817b8c") < 0){
        Message.error('您没有权限，可联系管理员添加权限！')
        return
      }
      this.downloadExcelShow = false
      const InstructionManualvv = await exportExcelQualityReport({workId:this.workId});
      console.log(InstructionManualvv)
      if(InstructionManualvv.data.byteLength < 80){
        this.downloadExcelShow = true
        return
      }
      let fileName = this.works[this.workIndex].name+'-质量'+getDateSeconds()+'.xlsx';
      let blob = new Blob([InstructionManualvv.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});  
      if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
      } else {
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href) //释放内存
      } 
      this.downloadExcelShow = true
    },
    toWorkCheck: function(){
      this.$router.push({path:'/transfer/workCheck',query:{workId:this.workId}});
    },
    toWorkRE: function(){
      this.$router.push({path:'/transfer/monitorRe',query:{workId:this.workId,workName:this.workName,type:'RE'}});
    },
    // 获取质量数据接口
    getAllInfo: function(workId){
      //console.log(workId)
      // this.loading = this.$loading({
      //     lock: true,
      //     text: 'Loading',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.7)'
      //   });
      this.loading = true
      let params = {
        workId: workId
      }
      rollingQualityTimes(params).then(res=>{
        this.rollingTimesData = res.data.content.info
      })
      rollingQualityIcv(params).then(res=>{
        this.rollingIcvData = res.data.content.info
        setTimeout(()=>{
          this.activeIndex1 = 0
          this.activeIndex2 = 0
          this.activeCode = 0
          this.loading = false;
          },2000)
      })
      // rollingQualityAltitude(params).then(res=>{
      //   this.rollingAltitudeData = res.data.content.info
      // })
      rollingQualityEfficiency(params).then(res=>{
        this.rollingEfficiencyData = res.data.content.info
      })
      pavingQualityTemperature(params).then(res=>{
        this.pavingQualityTemperatureData = res.data.content
      })
      pavingQualitySpeed(params).then(res=>{
        this.pavingQualitySpeed = res.data.content
      })
      pavingQualityEfficiency(params).then(res=>{
        this.pavingEfficiencyData = res.data.content.info
      })
    },
    workClick(id,name,index) {
      this.workIndex = index;
      this.workId = id
      this.workName = name
      let par = {
        id: id
      }
      console.log(this.activeCode)
      this.activeCode = -1
      
      this.getAllInfo(this.workId)
      getWorkInfo(par).then(res=> {
        //console.log(res)
        let roadWidth = (res.data.content.info.roadWidth);
        let deviationUnit = res.data.content.info.deviationUnit
        let setRoadWidth = [];
        let code = deviationUnit
        for (let i = 0; i <= 100; i++) {
          if(i*code<=(roadWidth*1+code*1)){
            setRoadWidth.push(code*10*i/10)
          }
        }
        this.$store.commit("setRoadWidth", setRoadWidth);
        this.$store.commit('deviationUnit', deviationUnit)
        
        this.workObj = res.data.content.info
        let workTypeList = this.$store.state.workTypeList
        let statusList = this.$store.state.statusList
        this.workObj.workTypeText = workTypeList[this.workObj.workType]
        this.workObj.statusText = statusList[this.workObj.status]
        //标准道路
        this.workObj.pecent =this.workObj.sumMileage==0?'0.0%':((this.workObj.curMileage/this.workObj.sumMileage)*100).toFixed(1) + '%'
        this.workObj.surplus = getNowDataNum(this.workObj.planEndTime)
        
        setTimeout(function(){
          this.activeIndex1 = 0
          this.activeIndex2 = 0
          },5000)
        if(this.workObj.workType == 1 || this.workObj.workType == 2){
            this.joinTypeV = 0
          }else{
            this.joinTypeV = 1
          }
      })
      
    },
    tabChange1(activeIndex) {
      //console.log(activeIndex)
      this.activeIndex1 = activeIndex;
    },
    tabChange2(activeIndex) {
      this.activeIndex2 = activeIndex;
    },
  },
  components: {
    TabPanel,
    pavingSpeed,
    pavingTemperature,
    pavingTrace,
    pavingEfficiency,
    rollingTrace,
    // rollingAltitude,
    rollingTimes,
    rollingIcv,
    rollingEfficiency
  },
};
</script>
<style lang="scss">
// .container2 {
//   .el-button{
//     span{
//       font-size: 8px !important;
//     }
//   }
  
// }
</style>
<style lang="scss" scoped="">
.worker-wrapper {
  margin-top: 10px;
}
.noDateShow{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.projectInfo {
  height: auto;
  padding-bottom: 21px;
  margin: 0 auto;
  background-color: #ffffff;
  margin-bottom: 12px;
  .blockHeader {
    width: 100%;
    height: 58px;
    position: relative;
    .workListTable {
      width: 1200px;
      height: 40px;
      position: absolute;
      top: 15px;
      left: 130px;
      // background-color: aquamarine;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;

      .workItem {
        &.activeWorkItem {
          background-color: #e96b5a;
          .workItemText {
            color: #ffffff;
          }
        }
        color: #e96b5a;
        background: #fdf0ef;
        border-color: #f6c4bd;
        height: 32px;
        width: auto;
        display: inline-block;
        line-height: 30px;
        font-size: 14px;

        margin-right: 10px;
        margin-left: 10px;
        // padding: 0 30px;
        vertical-align: top;
        border: 1px solid #e96b5a;
        box-sizing: border-box;
        transform: skewX(-20deg);
        cursor: pointer;
        .workItemText {
          display: inline-block;
          height: 100%;
          width: 100%;
          padding: 0 30px;
          line-height: 30px;
          transform: skewX(20deg);
        }
      }
    }
    .redBlock {
      height: 18px;
      width: 4px;
      position: absolute;
      background-color: #e96b5a;
      top: 19px;
      left: 0px;
    }
    .headerText {
      height: 16px;
      line-height: 16px;
      color: #222222;
      display: inline-block;
      position: absolute;
      top: 21px;
      left: 14px;
      font-weight: 600;
      font-size: 16px;
    }

    .addBtn {
      // position: absolute;
      // top: 15px;
      // right: 171px;
      float: right;
      border-radius: 2px;
      margin-top: 15px;
      
      span{
        font-size: 12px !important;
      }
    }

    .copyBtn {
      // position: absolute;
      // top: 15px;
      // right: 85px;
      float: right;
      border-radius: 2px;
      margin-top: 15px;
      margin-left: 12px;
    }
    .download{
      // position: absolute;
      // top: 15px;
      // right: 0px;
      float: right;
      border-radius: 2px;
      margin-top: 15px;
      margin-left: 12px;
    }
  }
  .parameterContent {
    width: 97.7%;
    height: auto;
    margin: 0 auto;
  }
  .blockContent {
    margin: 0 auto;
    border-top: 1px solid rgba(225, 225, 225, 1);
    border-left: 1px solid rgba(225, 225, 225, 1);

    .blockItem {
      display: flex;
      height: 45px;
      .item_type1 {
        flex: 1;
      }
      .item_type2 {
        flex: 2;
      }
      .itemLeft {
        width: 120px;
        height: 44px;
        float: left;
        background: rgba(242, 242, 245, 1);
        border-bottom: 1px solid rgba(225, 225, 225, 1);
        border-right: 1px solid rgba(225, 225, 225, 1);
        line-height: 44px;
        padding-left: 15px;
        color: #555555;
        font-size: 14px;
      }
      .itemRight {
        // width: 100%;
        height: 44px;
        line-height: 44px;
        padding-left: 18px;
        color: #555555;
        font-size: 14px;

        overflow: hidden;
        border-bottom: 1px solid rgba(225, 225, 225, 1);
        border-right: 1px solid rgba(225, 225, 225, 1);
        .infoShow {
          width: 100%;
          height: 100%;
          border: 0;
          color: #555555;
          font-size: 14px;
        }
      }
    }
  }
}
</style>